import React from "react";

/**
 * After waiting for an async operation we often want to call setState method.
 * If the component is no longer mounted this results in an error. This hook
 * returns whether the component is mounted or not allowing consumers to
 * determine if they should call their state methods or not.
 *
 * Uses an array of booleans to track the mounted state of all instances of
 * this hook so it works in React.StrictMode, which runs these useEffects
 * (and their cleanup functions) multiple times.
 */
export function useIsMounted(): () => boolean {
  const allMounted = React.useRef<boolean[]>([]);
  const stableCallback = React.useCallback(
    () => allMounted.current.some(Boolean),
    []
  );
  React.useEffect(() => {
    const index = allMounted.current.length;
    allMounted.current.push(true);
    return () => {
      allMounted.current[index] = false;
    };
  }, []);
  return stableCallback;
}
